import Packet from '@/models/Packet';
export const INVENTORY_PACKET_UNLIMITED = 1;
export const INVENTORY_PACKET_DATA = 2;
export default class Inventory {
  constructor(packets = {}, discounts = {}) {
    this.packets = packets;
    for (const scGroup of Object.keys(packets)) {
      for (const type of Object.keys(packets[scGroup])) {
        for (const id of Object.keys(packets[scGroup][type])) {
          const packet = this.packets[scGroup][type][id];
          if (discounts[packet.id] != null) {
            this.packets[scGroup][type][id] = new Packet(discounts[packet.id]);
          } else {
            this.packets[scGroup][type][id] = new Packet(packet);
          }
        }
      }
    }
  }

  getPackets(serviceClass, type) {
    const serviceClassPackets = this.packets[serviceClass] || {};
    return serviceClassPackets[type] || [];
  }

  empty() {
    return Object.keys(this.packets).length === 0;
  }
}
